<mat-icon *ngIf="hoverInfo" class="hover-info" [attr.title]="hoverInfo">info_outline</mat-icon>